export const data = [
  {
    name: "ジン",
    character:
      "工藤新一を幼児化させた張本人。長身痩躯の冷酷な男。鋭い観察力と狙撃の腕を持つ。赤井のライバル",
    detail:
      "大麦やライ麦, じゃがいもなどを原料とした蒸留酒。ジュニパーベリーによって香り付けされている無色透明のお酒。さっぱりすっきりした感じ。",
    data: true,
  },
  {
    name: "ウォッカ",
    character:
      "ジンの部下で、行動をともにしている。組織への忠誠心が高い。ヘリコプターの操縦ができるなどスキルも高い。",
    detail:
      "4大スピリッツのひとつでロシアや中東欧でよく親しまれている蒸留酒。ライ麦や大麦・小麦、ジャガイモなどの穀物が中心に作られていて、蒸留の過程で白樺の炭でろ過されている。エタノール味を除けばほぼ無味無臭。",
    data: true,
  },
  {
    name: "ベルモット",
    character:
      "表の顔はハリウッド女優。黒ずくめの組織の幹部であり、「あの方」のお気に入り。名言は「A secret makes a woman woman」",
    detail:
      "白ワインを主体とし、香草やスパイスを配合として作られるフレーバーワイン。スイートとドライの２種類があり、それぞれで味や香りが異なるらしい。",
    data: true,
  },
  {
    name: "キール",
    character:
      "黒ずくめ組織に潜入しているCIAの諜報員。元・日売テレビの人気アナウンサーで、組織でのコードネームは、キール。",
    detail: "白ワインに少量のカシスリキュールを加えたカクテル。",
    data: true,
  },

  {
    name: "バーボン",
    character:
      "黒ずくめの組織に潜入している公安警察官。組織でのコードネームは、バーボン。私立探偵としての顔も持つ切れ者。",
    detail:
      "とうもろこしをベースとしたアメリカで作られるウイスキー。甘みが強くバニラやカラメルを連想させる風味が特徴。",
    data: true,
  },
  {
    name: "ライ",
    character:
      "かつて組織に潜入していたFBI捜査官。「銀の弾丸」（シルバーブレット）の異名をもつ。黒ずくめの組織に殺されたと思われていたが……",
    detail:
      "ライ麦をベースとしたウイスキー。ライ麦由来の微かな苦味がありスパイシーな「ペンシルベニア・スタイル」とまろやかな「メリーランド・スタイル」がある。",
    data: false,
  },
  {
    name: "スコッチ",
    character:
      "以前降谷零と共に組織に潜入していた公安警察。スナイパーとして活躍しバーボンとライとともに行動していた。だが...",
    detail:
      "スコットランドで作られているウイスキー。大麦麦芽を単式蒸溜器で2回蒸溜するモルトウイスキー、主にトウモロコシを連続蒸溜器で蒸溜したグレーンウイスキー、この2つを混合したブレンデッドウイスキーがある。",
    data: true,
  },

  {
    name: "シェリー",
    character:
      "謎の黒ずくめの組織の一員だった宮野志保が、コナン同様、子供の姿になった。阿笠博士の家に居候し、コナン達の小学校に通う。",
    detail:
      "スペインで作られた酒精強化ワイン。白ブドウのみで作られる。酒精強化ワインなので通常のワインよりもアルコール度数が少し高い。食前酒として良く嗜まれる。",
    data: false,
  },

  {
    name: "キュラソー",
    character:
      "映画「純黒の悪夢」のみに登場したオッドアイの人物。卓越した運動能力と一度見たものを正しく記憶して置けるという能力を持っている。ラムの右腕",
    detail:
      "中世スピリッツやブランデーにオレンジの香りや糖分を加えたリキュール。オレンジのリキュールだが果汁や果肉は使わず、皮のみを使用して作られている。色のバリエーションが白・橙・赤・緑・青と5色ある。",
    data: true,
  },
  {
    name: "ラム",
    character:
      "組織のNo.2。組織のメンバーでもこの人物の正体を知る人は数少ない。左右どちらかの目が義眼と言われている。",
    detail:
      "サトウキビの廃糖蜜または絞り汁を原料として作られる蒸留酒。木樽に入れて樽香をつけながら熟成されることが多い。アルコール飲料以外にも焼き菓子の風味付けにも多く使われる。",
    data: true,
  },
  {
    name: "キャンティ",
    character:
      "精密な狙撃ができる女スナイパー。左目の周りにアゲハ蝶のようなタトゥーが入っている。ベルモットに噛み付いている姿が良くみられる。口が悪い。",
    detail:
      "イタリア産のワイン。軽めの赤ワインで、肉料理に良く合うとされている。",
    data: false,
  },
  {
    name: "コルン",
    character:
      "キャンティと行動を共にするこちらも腕の良いスナイパー。キャンティとは全く対照的で、口数がとても少ない。",
    detail:
      "ドイツ西部で生産される穀物由来の蒸留酒。香り付けがされていないのでこれといって風味がないのが特徴らしい。",
    data: false,
  },

  {
    name: "テキーラ",
    character:
      "関西弁と口髭が特徴的な大柄な男。コンピュータープログラムに関する取引に関わっていたがそこで...",
    detail:
      "メキシコのお酒で、竜舌蘭を原料とする「メスカル」という酒の一種。ライムを口の中に直接絞り、それと交互に飲み、最後に塩を舐めるのが正式な飲み方とされている",
    data: true,
  },

  {
    name: "カルバドス",
    character:
      "腕の良いスナイパーでベルモットのサポートをしていた。キャンティとコルンと仲がよかった人物。",
    detail:
      "りんごを使った蒸留酒でフランス・ノルマンディー地方で作られるもののことを特にこう呼ぶ。フランスではよく食後に嗜まれている。",
    data: true,
  },
  {
    name: "アイリッシュ",
    character:
      "映画「漆黒の追跡者」のみに登場した人物。ピスコを父のように慕っていたため...",

    detail:
      "アイルランド共和国と北アイルランドの２国にまたがる地域で作られているウイスキー。独特なオイリーなフレーバーと雑味の少ないマイルドな風味が特徴らしい。",
    data: true,
  },
  {
    name: "スタウト",
    character:
      "映画「純黒の悪夢」に登場した人物。CSISからスパイとして黒の組織に潜入していたが...",

    detail:
      "ビールのスタイルの一つで香ばしいナッツやチョコレート、コーヒーのような香りが特徴の黒系のビール。",
    data: false,
  },
  {
    name: "アクアビット",
    character:
      "映画「純黒の悪夢」に登場した人物。CSISからスパイとして黒の組織に潜入していたが...",
    detail:
      "じゃがいもを主原料とした蒸留酒。ノルウェーやデンマーク、スウェーデン、ドイツで製造されている。味や香りにクセがあるらしい。",
    data: false,
  },
  {
    name: "リースリング",
    character:
      "映画「純黒の悪夢」に登場した人物。CSISからスパイとして黒の組織に潜入していたが...",
    detail:
      "ドイツ原産の白ブドウの品種のことを指す。リースリングで作られるワインは、甘口から辛口までさまざまなタイプの白ワインやスパークリグワインになる。",
    data: false,
  },
  {
    name: "ピスコ",
    character:
      "表の顔は自動車メーカーの会長で経済界の大物。だいぶ高齢だが、組織のトップである「あの方」に長年使えていたらしい。シェリーの幼少期の姿を知っている。",
    detail:
      "ペルー原産のブドウ果汁を原料とした蒸留酒。アルコール度数が４０度前度あるのでうっかりストレートで飲むとカッとなる。カクテルの材料にもなる",
    data: false,
  },
];
